import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { Box, IconButton, InputBase, SxProps, styled } from '@mui/material';

export interface SearchTextFieldProps {
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  sx?: SxProps;
  onChange(value: string): void;
}

export function SearchTextField({
  sx,
  placeholder,
  value,
  defaultValue,
  onChange,
}: SearchTextFieldProps) {
  return (
    <Root sx={sx}>
      <SearchRounded sx={{ color: 'neutral.main' }} />
      <InputBase
        fullWidth
        defaultValue={defaultValue}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {!!value && (
        <IconButton size="small" sx={{ mr: -1 }} onClick={() => onChange('')}>
          <CloseRounded />
        </IconButton>
      )}
    </Root>
  );
}

const Root = styled(Box)(({ theme }) => ({
  width: 300,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '0 12px',
  borderRadius: 20,
  backgroundColor: theme.palette.background.paper,
}));
